import * as React from 'react';
import { Translate } from 'react-jhipster';
import { Row, Col } from 'reactstrap';

export class Privacy extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <Row className="justify-content-center">
        <Col md="8" className="bg-white">
          <Row className="justify-content-center">
            <Col md="8" className="m-3">
              <h1>
                <Translate contentKey="static.privacy.title">Privacy Policy</Translate>
              </h1>
              <p>
                PATO ENTERTAINMENT realize the significance to safeguard the privacy of personal data collected about our customers. For the
                goal of this Privacy policy, the word 'customer' defines visitors who access to our web sites, subscribers as well as
                purchasers of our events.
              </p>

              <p>1. Third Parties</p>
              <p>
                PATO ENTERTAINMENT do observe and be bound accordingly by the "Personal Data (Privacy) Ordinance Cap.486, Laws of Hong Kong.
                Only for third parties such as our appointed technical service providers, contractors, including our call center operators,
                and software contractors are authorized to access the system as part of their job capacity.
              </p>

              <p>2.Personal Data and Usage</p>
              <p>
                During the purchasing process we will collect personal data from customers. We normally require personal data such as your
                name, phone number, email address, delivery address and your credit card details. We use such information for the goal of
                delivering our services to you, and execute our administrative procedure in related with these services.<br />
                Once you have registered a successful purchase of our event tickets, we will save your contact and delivery details. Such
                details are adopted to provide you with the ticketing services you have requested and to update you more information about
                our events. Your booking data may be provided to the event organizer upon their request for the purpose of disputes
                resolution or integrated analysis.
              </p>

              <p>3.Security</p>
              <p>
                PATO ENTERTAINMENT tackles to protect the privacy, security, and integrity of our customers. We use a mixture of physical
                and electronic security system to prevent physical access to our firewalls and secure our databases from harmful access.
              </p>
              <p>4.Use of Accumulated Data.</p>
              <p>
                We will gather some non-personal information through webpages (such as your IP address and the domain name of your Internet
                service provider, the identity of your Internet browser, the sort of system you are adopting, . PATO ENTERTAINMENT may apply
                such information to improve our system and services to be more powerful and responsive. However, no data communication over
                the Internet world can be guaranteed 100% secured.
              </p>

              <p>5.Cookies</p>
              <p>
                Cookies are defined as a data of communication where a web site transmits to another individual's hard drive to preserve
                record. It enables us to keep track of the patterns so as to improve our system.<br />
                In case you do not want to collect the use of Cookies, there is a simple step in most browsers that can allow you to select
                either deny or accept the Cookie function. However you should notice that Cookies are necessary to give you components such
                as merchandise deals or registered services.
              </p>

              <p>6.Reminder about privacy on the Internet</p>
              <p>
                We strongly advise you to close your browser after you have ended the transaction. This is to safeguard that others cannot
                access your data whenever you share a computer with friends or using a computer in a place like Internet cafe or public
                area. Please be careful and responsible whenever you are using the Internet.
              </p>

              <p>7.Anti piracy</p>
              <p>
                Software piracy crashes the software industry worldwide. From time to time we will review reports of suspected piracy and
                proceed investigation against those reports. Software piracy is a criminal offence.
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default Privacy;
